import type { CustomControlCode } from '@common/enums';
import type { Field, Section } from '@common/formEngine/formEngine.types';
import type { IPatientContactDetails } from '@common/interfaces/patientContactDetails';
import type { HolterExaminationRequestContentKeys } from './holterExaminationRequestSchemas';
import type {
    HolterExaminationRequestAdvice,
    HolterExaminationRequestBase,
    HolterReferralData,
    HolterReferralRecipientData,
} from './utils/utils';
import { patientPhoneAndEmailDraftSchema, patientPhoneAndEmailFinalSchema } from '../../patientContactDetailsSchema';
import { getServiceOrganizationProviderSchema } from '../../serviceOrganizationProvider';
import {
    holterAnamnesisSection,
    holterHistorySection,
    holterRustEcgSection,
    medicationSection,
} from './hollterRequestsSchemas';
import {
    adviceSection,
    diagnosisSection,
    holterRiskFactorsSection,
    holterSetupSection,
    professionalSummarySection,
    referralSectionBaseFields,
} from './holterExaminationRequestSchemas';

export type HolterExternalExaminationRequestData = HolterExaminationRequestBase &
    HolterExaminationRequestAdvice &
    HolterReferralData &
    HolterReferralRecipientData & {
        patient: IPatientContactDetails;
    };

export const patientPhoneAndMailSection: Section<{ patient: IPatientContactDetails }> = {
    fields: [
        {
            draftSchema: patientPhoneAndEmailDraftSchema,
            finalSchema: patientPhoneAndEmailFinalSchema,
            initialValue: {
                emailAddress: null,
                homePhoneNumber: null,
                mobileNumber: null,
            },
            isRequired: true,
            key: 'patient',
            label: 'Contactgegevens patiënt',
            type: 'custom',
        },
    ],
};

const referralSectionRecipientFields: Array<Field<HolterReferralRecipientData>> = [
    {
        draftSchema: getServiceOrganizationProviderSchema(true),
        finalSchema: getServiceOrganizationProviderSchema(),
        initialValue: {
            organizationId: null,
            practitionerId: null,
        },
        key: 'recipient',
        label: 'Verstuur naar',
        type: 'custom',
    },
];

export const referralSectionWithRecipient: Section<
    HolterReferralData & HolterReferralRecipientData,
    undefined,
    CustomControlCode.HolterExternalExaminationRequest
> = {
    fields: [...referralSectionBaseFields, ...referralSectionRecipientFields],
    title: 'Verwijzing',
};

export const holterExternalExaminationRequestSections: Section<
    HolterExternalExaminationRequestData,
    HolterExaminationRequestContentKeys,
    CustomControlCode.HolterExternalExaminationRequest
>[] = [
    referralSectionWithRecipient,
    holterSetupSection,
    holterAnamnesisSection,
    holterRustEcgSection,
    holterHistorySection,
    medicationSection,
    adviceSection,
    holterRiskFactorsSection,
    professionalSummarySection,
    diagnosisSection,
    patientPhoneAndMailSection,
];
